<template>
    <div class="full-page bg-primary">
        <div v-if="!success" class="uk-card uk-card-body uk-card-default uk-position-center">
            <h1 class="uk-card-title">Geef je emailadres in</h1>
            <div class="uk-margin">
                <input class="uk-input" type="email" name="email" v-model="email" placeholder="Uw Emailadres"/>
            </div>
            <div v-if="error" class="uk-alert-danger">{{error.code}}</div>
            <button class="uk-button uk-button-primary uk-align-right" type="submit" :disabled="loading" @click.prevent="ForgotPassword"><span v-if="!loading">VERZENDEN</span><div v-if="loading" uk-spinner></div></button>
            <router-link to="login">Aanmelden</router-link>
        </div>
        <div v-if="success" class="uk-card uk-card-body uk-card-default uk-position-center">
            <h1 class="uk-card-title">Email verzonden!</h1>
        </div>
    </div>
</template>
<script>
import {db, auth} from '@/CUSTOM/helpers/firebase'
    export default {
        name: 'ForgotPassword',
        data () {
            return {
                email: '',
                error: null,
                success: false,
                loading: false
            }
        },
        created() {
            this.$emit('loading', false)
        },
        methods: {
            ForgotPassword () {
                this.loading=true
                auth.sendPasswordResetEmail(this.email).then(() => {
                    this.success = true
                    this.loading = false
                }).catch((error) => {
                    this.loading = false
                    this.error = error
                    if(error.code == 'auth/user-not-found') {
                        this.success = true
                    }
                // An error happened.
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ForgotPassword.vue?067005e5